import { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { WaitingComprobationToken } from "../auth/pages";
import { AuthRoutes } from "../auth/routes/AuthRoutes";
import { FaradayRoutes } from "../faraday/routes/FaradayRoutes";
import { startSignInWithToken } from "../store/auth/thunks";




export const AppRouter = () => {

    const dispatch = useDispatch();
    const [isTokenVerificated, setIsTokenVerificated] = useState(false)


    const { status } = useSelector(state => state.auth);

    useEffect(() => {
        if (localStorage.getItem('token') || sessionStorage.getItem('token')) {
            dispatch(startSignInWithToken())
        }
        setTimeout(function(){
            setIsTokenVerificated(true)
        },500)
    }, [dispatch])


    return (
        <Routes>
            {
                isTokenVerificated
                    ? (
                        <>
                            {
                                (status === 'authenticated')
                                    ? <Route path='/*' element={<FaradayRoutes />} />
                                    : <Route path='/auth/*' element={<AuthRoutes />} />
                            }

                            <Route path='/*' element={<Navigate to='/auth/login' />} />
                        </>
                    )
                    :
                    (
                        <Route path='/*' element={<WaitingComprobationToken/>} />
                    )

            }
        </Routes>
    )
}
